import { Attachment, AttachmentType, ImageAttachment, VideoAttachment } from '../../types';

const OPEN_TAG = /</g;
const CLOSE_TAG = />/g;
const LINE_FEED = /\r?\n/g;
const LINK = /(\b(www\.|https?:\/\/)[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
const WWW = /^www\./;

// Zero dims = the probe couldn't decode the file; omit so the media isn't rendered 0×0.
const dimensionAttrs = ({ width, height }: { width: number; height: number }): string =>
  width && height ? ` width="${width}" height="${height}"` : '';

const createImage = (a: ImageAttachment) => {
  return `<img src="${a.url}"${dimensionAttrs(a)} alt="${a.name}"/>`;
};

const createVideo = (a: VideoAttachment) => {
  // format is canonicalized to a browser-playable type upstream by probeMediaDimensions
  return `<video${dimensionAttrs(a)} controls><source src="${a.url}" type="video/${a.format}"></video>`;
};

const createLink = (link: string) => {
  const url = WWW.test(link) ? `//${link}` : link;

  return `<a href="${url}" rel="noopener noreferrer" target="_blank">${link}</a>`;
};

export const createHTML = (value: string, attachments: Attachment[]) => {
  const media = attachments
    .map((a) => (a.type === AttachmentType.Image ? createImage(a) : createVideo(a)))
    .join('');
  const escaped = value
    .replace(OPEN_TAG, '&lt;')
    .replace(CLOSE_TAG, '&gt;')
    .replace(LINE_FEED, '<br/>')
    .replace(LINK, createLink);
  const messageHtml = `<div data-hook="user-message">${escaped}</div>`;

  return {
    htmlWithAttachments: `${messageHtml}<div data-hook="user-attachments">${media}</div>`,
    htmlWithoutAttachments: messageHtml,
  };
};
